module.exports = __webpack_public_path__ + "static/lab-d3eae32621219c7d6a3b955863e3af55.mp4";